import App from './pages/App';
import main from './indexWrap';
main(App);
